module.exports = __webpack_public_path__ + "media/images/course/depo_02-38543d417090b05884c23fd691c5cdcd.png";